import FieldType from "../datamodule/FieldType";

class ViewType {
    static QUERY = 'query';
    static TITLE = 'title';
    static FORM = 'form';
    static TABLE = 'table';
    static SELECTIONS = 'selections';
    static TAB = 'tab';
    static PAGE = 'page';

    static testField(field) {
        if (field instanceof Object) {
            switch (field.type) {
                default:
                    return field;
                case FieldType.QUERY:
                case FieldType.TITLE:
                case FieldType.FORM:
                case FieldType.TABLE:
                case FieldType.SELECTIONS:
                case FieldType.TAB:
                    if (config.config) return config;
                    return {type:field.type, name:field.name, config:field};
            }
        } else return field;
    }
    static testFields(fields) {
        const fs = [];
        for (const field of fields) {
            fs.push(ViewType.testField(field));
        }
        return fs;
    }
}

export default ViewType;